var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    containerBorderColor: colors.contrasts.grey1214,
    pastDueColor: colors.contrasts.red4570,
    containerPadding: spacing.xSmall,
    iconWrapperMargin: spacing.xSmall
  };
};
export default generateComponentTheme;